import { PlusIcon, TrashIcon } from "@heroicons/react/24/solid";

const LinkForm = ({
    LINK_URL,
    LINK_NAME,
    newLink,
    handleChange,
    addLink,
    deleteLink,
    inputLinksJSON = [],
    divWidth = "",
    title,
    showName = true,
    allowMultiple = true,
}) => {
    return (
        <div className={`mt-1 ${divWidth}`}>
            <label className="block text-sm font-medium text-gray-700">
                {title}
            </label>

            {/* Campo Name opcional */}
            {showName && (
                <div className="mt-2">
                    <label
                        htmlFor={LINK_NAME}
                        className="block text-sm font-medium text-gray-700"
                    >
                        Name
                    </label>
                    <input
                        name={LINK_NAME}
                        onChange={handleChange}
                        type="text"
                        className="w-full p-1 px-2 mt-1 border rounded-sm shadow-sm border-slate-200 focus:outline-none"
                        value={newLink[LINK_NAME]}
                    />
                </div>
            )}

            {/* Siempre mostramos el campo URL */}
            <div className="mt-4">
                <label
                    htmlFor={LINK_URL}
                    className="block text-sm font-medium text-gray-700"
                >
                    URL
                </label>
                <input
                    name={LINK_URL}
                    onChange={handleChange}
                    type="url"
                    className="w-full p-1 px-2 mt-1 border rounded-sm shadow-sm border-slate-200 focus:outline-none"
                    value={newLink[LINK_URL]}
                    required
                />

                {/* Botón para añadir enlaces si allowMultiple */}
                {allowMultiple && (
                    <button
                        onClick={addLink}
                        type="button"
                        className="inline-flex items-center p-1 mt-2 text-white bg-teal-500 border border-transparent rounded-sm shadow-sm hover:bg-teal-600 focus:outline-none"
                    >
                        <PlusIcon className="w-5 h-5" /> Add link
                    </button>
                )}
            </div>

            {/* Lista de enlaces si allowMultiple */}
            {allowMultiple && (
                <div className="w-full mt-4 bg-white border rounded-sm shadow-lg border-slate-200">
                    {inputLinksJSON.map((link) => (
                        <div
                            key={link[LINK_URL]}
                            className="flex items-center justify-between px-5 py-4 border-b border-slate-200"
                        >
                            <a
                                href={link[LINK_URL]}
                                target="_blank"
                                rel="noreferrer"
                                className="text-blue-600 hover:underline"
                            >
                                {link[LINK_NAME]}
                            </a>
                            <button
                                onClick={() => deleteLink(link[LINK_NAME])}
                                type="button"
                                className="inline-flex items-center p-1 text-black border border-transparent rounded-sm shadow-sm hover:text-red-600 focus:outline-none"
                            >
                                <TrashIcon className="w-5 h-5" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LinkForm;
